import { DepartmentResponseView } from "../components/DepartmentResponseView";
import { Layout } from "../components/Layout";
import { Panel } from "../components/Panel";
import { getDemoSession } from "../lib/demoAuth";
import { getWorkspaceState } from "../lib/workspaceStore";
import { canSessionAccessDepartmentResponse } from "../lib/workspaceAccess";

interface AdminDepartmentResponsesProps {
  workspaceId: string;
  departmentId: string;
}

export function AdminDepartmentResponses({ workspaceId, departmentId }: AdminDepartmentResponsesProps) {
  const state = getWorkspaceState();
  const session = getDemoSession();
  const workspace = state.workspaces.find((item) => item.id === workspaceId);
  const department = state.departments.find((item) => item.id === departmentId && item.workspaceId === workspaceId);
  const response = state.departmentResponses.find((item) => item.departmentId === departmentId && item.workspaceId === workspaceId);

  if (!department || !workspace || !canSessionAccessDepartmentResponse(state, session, department)) {
    return (
      <Layout
        eyebrow="Keine Berechtigung"
        title="Sie haben für diese Ansicht keine Berechtigung."
        description="Diese Antwortansicht ist nur für HAUFFE Admins freigegeben."
      >
        <div className="hero-actions">
          <a className="button button-primary" href="/admin">
            Zurück zur Admin-Übersicht
          </a>
        </div>
      </Layout>
    );
  }

  return (
    <Layout
      eyebrow="HAUFFE Admin"
      title="Abteilungsantworten ansehen"
      description={`${workspace.name}: Antworten der Abteilung ${department.name}.`}
    >
      <Panel title="Antwortansicht" variant="accent">
        <DepartmentResponseView department={department} response={response} audience="admin" />
      </Panel>
      <div className="hero-actions">
        <a className="button button-primary" href={`/admin/workspaces/${workspace.id}`}>
          Zurück zum Workspace
        </a>
      </div>
    </Layout>
  );
}
